//
//  src/components/google/Google.js
//
import { sha256 } from "../../utils/Hash";

const SUCCESS_DEFAULTS = {
    form: {
        event_label: "Contact Form Sent",
        booking_value: 50,
        contact_type: "form",
    },
    wizard: {
        event_label: "Tattoo Enquiry Sent",
        booking_value: 75,
        contact_type: "wizard",
    },
};

const ERROR_DEFAULTS = {
    form: {
        event_label: "Contact Form Error",
        contact_type: "form",
    },
    wizard: {
        event_label: "Tattoo Enquiry Error",
        contact_type: "wizard",
    },
};

export async function pushContactSuccess(source, data, fileCount) {
    if (typeof window === "undefined") return;
    const defaults = SUCCESS_DEFAULTS[source] || SUCCESS_DEFAULTS.form;

    window.dataLayer = window.dataLayer || [];
    const hashedName = await sha256(data.from_name || "");
    const hashedEmail = await sha256(data.from_email || "");

    window.dataLayer.push({
        event: "contact_form",
        event_category: "Contact",
        event_label: defaults.event_label,
        event_state: "success",
        booking_value: defaults.booking_value,
        customer_name: hashedName,
        customer_email: hashedEmail,
        contact_type: data.type || defaults.contact_type,
        referrer_code: data.referrer_code || "",
        has_attachments: fileCount > 0,
        attachment_count: fileCount,
        message_length: data.message ? data.message.length : 0,
        enquiry_type: data.enquiry_type || "",
        enquiry_style: data.enquiry_style || "",
        enquiry_placement: data.enquiry_placement || "",
        enquiry_timeline: data.enquiry_timeline || "",
        contact_preference: data.contact_preference || "",
        marketing_opt_in: data.marketing_opt_in === "1" || !!data.marketing_opt_in,
    });
}

export async function pushContactError(source, data, fileCount) {
    if (typeof window === "undefined") return;
    const defaults = ERROR_DEFAULTS[source] || ERROR_DEFAULTS.form;

    window.dataLayer = window.dataLayer || [];
    const hashedName = await sha256(data.from_name || "");
    const hashedEmail = await sha256(data.from_email || "");

    window.dataLayer.push({
        event: "contact_form",
        event_category: "Contact",
        event_label: defaults.event_label,
        event_state: "error",
        customer_name: hashedName,
        customer_email: hashedEmail,
        contact_type: data.type || defaults.contact_type,
        referrer_code: data.referrer_code || "",
        has_attachments: fileCount > 0,
        attachment_count: fileCount,
        message_length: data.message ? data.message.length : 0,
    });
}
